// 商户平台-导航-点击
export const MERCHANT_NAVIGATION_CLICK = {
  '/homePage': '首页',
  '/orgnization/orgnizationList': '组织机构-升级版',
  '/company/companyManager': '组织机构-机构管理',
  '/company/groupManager': '组织机构-团队管理',
  '/company/salesManager': '组织机构-业务员管理',
  '/activity/activityReward': '组织机构-业务员推荐奖励',
  '/productSys/productRepository': '产品库-产品库',
  '/productSys/underwriting': '产品库-闪电核',
  '/activity/activitylist': '活动管理-活动管理',
  '/proposalSys/reserveOrder': '订单管理-撤销订单',
  '/proposalSys/longOrder': '订单管理-投保单',
  '/policySys/onlinePolicy': '保全管理-线上保单',
  '/policySys/orderPolicy': '保单管理-订单管理',
  '/policySys/appointPolicy': '保单管理-预约投保单',
  '/preservationSys/preservation': '保单管理-保全管理',
  '/policySys/freeOrder': '保单管理-赠险保单',
  '/offlinePolicy/offlinePolicy': '保单管理-线下保单',
  '/policySys/returnVisit': '保单管理-回执回访',
  '/shopSys/shopAdorn': '商城管理-展业端配置',
  '/businessReport/orgReportM': '业务统计-机构人员业务统计',
  '/businessReport/spuReportM': '业务统计-保险产品业务统计',
  '/businessReport/addPeople': '业务统计-业务员增员统计',
  '/transformingAndTrading/order': '转化与服务-预约跟进',
  '/settlement/continueRate': '财务结算-续期继续率',
  '/settlement/myIncome': '财务结算-我的收入',
  '/clientSys/clientAnalyze': '客户管理-客户分析',
  '/clientSys/clientManage': '客户管理-客户管理',
  '/system/accountManage': '系统管理-账号管理',
  '/system/invManage': '系统管理-账号管理',
  '/system/accountSafety': '系统管理-账号安全',
  '/system/salesQualification/agentQualification': '系统管理-销售资质',
  '/system/salesQualification/insuranceCompanyWork': '系统管理-销售资质-保司工号',
  '/system/salesQualification/toApplyForNo': '系统管理-销售资质-申请上号',
  '/system/roleMannagers': '系统管理-角色组管理',
  '/system/brandManage': '系统管理-品牌配置',
  '/groupIns/groupProduct': '团险管理-产品列表',
  '/groupIns/groupOrder': '团险管理-订单列表',
  '/groupIns/groupRecording': '团险管理-录单',
  '/continueRate/statistics': '继续率-继续率统计',

};
